<template>
  <b-card no-body>
    <b-card-header class="d-flex justify-content-between mb-2">
      <div>
        <b-card-title class="mb-2 text-white font-weight-bolder h2">
          My trading accounts
        </b-card-title>
        <b-card-sub-title class="small"
          >current status of your trading accounts</b-card-sub-title
        >
      </div>
      <div class="d-flex align-items-center mt-1 mt-md-0">
        <b-button
          class="mr-1 gradient-btn py-1"
          :to="{ name: 'accounts-create' }"
          ><small>Add accounts</small></b-button
        >
        <b-button class="py-1" :to="{ name: 'accounts' }"
          ><small>Manage accounts</small></b-button
        >
      </div>
    </b-card-header>
    <b-card-body>
      <div v-if="loading">
        <b-skeleton height="40px" class="w-100 mx-50"></b-skeleton>
        <b-skeleton height="40px" class="w-100 mx-50"></b-skeleton>
        <b-skeleton height="40px" class="w-100 mx-50"></b-skeleton>
        <b-skeleton height="40px" class="w-100 mx-50"></b-skeleton>
        <b-skeleton height="40px" class="w-100 mx-50"></b-skeleton>
        <b-skeleton height="40px" class="w-100 mx-50"></b-skeleton>
        <b-skeleton height="40px" class="w-100 mx-50"></b-skeleton>
      </div>
      <vue-apex-charts
        v-else-if="accounts.dates && accounts.dates.length"
        type="area"
        height="350"
        :options="chartOptions"
        :series="series"
      />
      <template v-else>
        <div
          class="d-flex align-items-center pt-4 justify-content-center h-100 new-alert"
        >
          <b-alert
            show
            variant="secondary"
            class="d-flex align-items-center justify-content-center p-3 h-100 w-100"
          >
            no information
          </b-alert>
        </div>
      </template>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard,
  BCardHeader,
  BCardBody,
  BCardSubTitle,
  BCardTitle,
  BButton,
  BSkeleton,
  BAlert,
} from "bootstrap-vue";
import VueApexCharts from "vue-apexcharts";

export default {
  components: {
    BCard,
    BCardHeader,
    BCardBody,
    BCardSubTitle,
    BCardTitle,
    BButton,
    VueApexCharts,
    BSkeleton,
    BAlert,
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    accounts: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    series() {
      let data = [];
      this.accounts.names.forEach((name) => {
        let newObj = [];
        this.accounts.dates.forEach((date) => {
          newObj.push(
            this.accounts.records[name][date]
              ? this.accounts.records[name][date]
              : 0
          );
        });
        data.push({
          name,
          data: newObj,
        });
      });
      return data;
    },
    chartOptions() {
      return {
        chart: {
          height: 350,
          type: "area",
          toolbar: {
            autoSelected: "pan",
            show: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: "smooth",
        },

        legend: {
          show: false,
        },
        // colors: ["#39A4F8", "#F7617D", "#FECD54"],
        fill: {
          type: "gradient",
          gradient: {
            shadeIntensity: 0.2,
            inverseColors: false,
            opacityFrom: 0.25,
            opacityTo: 0.05,
          },
        },
        xaxis: {
          categories: [...this.accounts.dates],
        },
        tooltip: {
          show: false,
        },
      };
    },
  },
};
</script>
<style>
.apexcharts-series-markers {
  display: none;
}
</style>
